import React, { Fragment } from 'react';
import pt from 'prop-types';
import { Form, Field, Button } from 'components/form';
import { FadeInUp, FadeIn } from 'components/transitions';
import SwellLogo from 'components/logo/logo';
import {
  CreateAccountFields,
  SignInFields,
  RecoverNote,
} from './account-fields';
import './login.scss';

const FADE_IN_DURATION = 500;

const JOIN_OPTIONS = [
  { value: 'new', label: "I'm new here" },
  { value: 'existing', label: 'I have an account' },
];

export default class JoinPage extends React.PureComponent {
  static propTypes = {
    invited: pt.shape({
      client_name: pt.string.isRequired,
      email: pt.string,
      name: pt.string,
    }),
    logo: pt.node,
    subheading: pt.node,
    onSubmitJoin: pt.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      tab: 'new', //this.props.invited.requires_login ? 'existing' : 'new',
    };
  }

  onChangeTab = (event, tab) => {
    this.setState({ tab });
  };

  renderSubmitButton() {
    const { invited } = this.props;

    return (
      <Button type="submit" styleType="default" size="large">
        Join <span className="capitalized">{invited.client_name}</span>
      </Button>
    );
  }

  render() {
    const { invited, onSubmitJoin, logo, subheading } = this.props;
    const { tab } = this.state;

    return (
      <div className="login-form login-form-join">
        <FadeInUp>
          <div>
            <div className="logo-container">{logo || <SwellLogo />}</div>
            <div className="login-subheading">
              {subheading || (
                <Fragment>
                  Create an account or log in to join{' '}
                  <span className="login-subheading-bold capitalized">
                    {invited.client_name}
                  </span>{' '}
                  store.
                </Fragment>
              )}
            </div>
            <Form onSubmit={onSubmitJoin} autoFocus={true}>
              <Field
                type="radio"
                name="tab"
                className="login-join-tabs login-form-field-margin-24"
                options={JOIN_OPTIONS}
                onChange={this.onChangeTab}
                defaultValue={tab}
                buttons
                readonly
              />
              {tab === 'new' && (
                <FadeIn duration={FADE_IN_DURATION}>
                  <CreateAccountFields
                    defaultName={invited.name}
                    defaultEmail={invited.email}
                  />
                  <div className="login-actions">
                    {this.renderSubmitButton()}
                  </div>
                </FadeIn>
              )}
              {tab === 'existing' && (
                <FadeIn duration={FADE_IN_DURATION}>
                  {/* showRecover={false} suppresses the fieldset's own note: this
                      screen renders it itself, after the submit button */}
                  <SignInFields
                    defaultEmail={invited.email}
                    showRecover={false}
                  />
                  <div className="login-actions">
                    {this.renderSubmitButton()}
                    <RecoverNote />
                  </div>
                </FadeIn>
              )}
            </Form>
          </div>
        </FadeInUp>
      </div>
    );
  }
}
